module.exports = __webpack_public_path__ + "static/media/mediopie.62afba70.png";